import type {
  BirthdayMembersDto,
  DailyScheduleListDto,
  SlotParticipantLightDto,
  TrialsDropInsBirthdaysDto,
} from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { DailyScheduleSlotEntityBuilder } from "@/modules/boxDashboard/modules/DailySchedule/tests/dailyScheduleSlotEntity.builder"
import dayjs from "dayjs"

export const DAILY_SCHEDULE_SLOT_DEFAULT = DailyScheduleSlotEntityBuilder.create().buildDto()

export const SLOT_PARTICIPANT_DEFAULT: SlotParticipantLightDto = {
  boxMemberId: "member-default",
  username: "johndoe",
  firstname: "John",
  lastname: "Doe",
  slotStart: dayjs().hour(10).minute(0).toISOString(),
  programName: "WOD",
  assignedStaffMembers: {
    id: "coach-default",
    username: "janesmith",
    firstname: "Jane",
    lastname: "Smith",
    avatar: null,
  },
}
export const BIRTHDAY_MEMBER_DEFAULT: BirthdayMembersDto = {
  boxMemberId: "member-birthday-default",
  username: "johndoe",
  firstname: "John",
  lastname: "Doe",
  slotStart: dayjs().hour(10).minute(0).toISOString(),
  programName: "WOD",
  assignedStaffMembers: {
    id: "coach-default",
    username: "janesmith",
    firstname: "Jane",
    lastname: "Smith",
    avatar: null,
  },
  lastSessionDate: null,
  nextSessionDate: null,
}

export const TRIALS_DROPINS_DAY_DEFAULT: TrialsDropInsBirthdaysDto = {
  dayDate: dayjs().format("YYYY-MM-DD"),
  numberOfTrials: 0,
  numberOfDropIns: 0,
  numberOfBirthdays: 0,
  trials: null,
  dropIns: null,
  birthdays: null,
}

export const DAILY_SCHEDULE_LIST: DailyScheduleListDto = [
  // Morning slots
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-1")
    .withTimeRange(6, 0, 7, 0)
    .withProgramName("Open Gym")
    .withColor("#4CAF50")
    .withCoach("Marcus", "Johnson")
    .withParticipants(6, 8, 0)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-2")
    .withTimeRange(7, 0, 8, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Sandra", "Graham")
    .withParticipants(12, 15, 1)
    .withTrials(2)
    .withDropIns(1)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-3")
    .withTimeRange(8, 0, 9, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Gregory", "Miller")
    .withParticipants(15, 18, 0)
    .withTrials(1)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-4")
    .withTimeRange(9, 0, 10, 0)
    .withProgramName("Yoga")
    .withColor("#9C27B0")
    .withCoach("Emma", "Wilson")
    .withParticipants(10, 12, 2)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-5")
    .withTimeRange(10, 0, 11, 0)
    .withProgramName("CrossFit Kids")
    .withColor("#2196F3")
    .withCoach("Alice", "Martinez")
    .withParticipants(8, 10, 0)
    .buildDto(),

  // Midday slots
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-6")
    .withTimeRange(12, 0, 13, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Sandra", "Graham")
    .withParticipants(18, 20, 0)
    .withTrials(3)
    .withDropIns(2)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-7")
    .withTimeRange(13, 0, 14, 0)
    .withProgramName("Open Gym")
    .withColor("#4CAF50")
    .withCoach("Marcus", "Johnson")
    .withParticipants(4, 6, 0)
    .buildDto(),

  // Afternoon/Evening slots
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-8")
    .withTimeRange(17, 0, 18, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Gregory", "Miller")
    .withParticipants(20, 22, 2)
    .withTrials(2)
    .withDropIns(1)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-9")
    .withTimeRange(18, 0, 19, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Sandra", "Graham")
    .withParticipants(22, 25, 1)
    .withTrials(1)
    .withDropIns(2)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-10")
    .withTimeRange(19, 0, 20, 0)
    .withProgramName("Weightlifting")
    .withColor("#FF9800")
    .withCoach("Michael", "Brown")
    .withParticipants(12, 14, 0)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-11")
    .withTimeRange(20, 0, 21, 0)
    .withProgramName("Open Gym")
    .withColor("#4CAF50")
    .withCoach("Emma", "Wilson")
    .withParticipants(3, 5, 0)
    .buildDto(),
]

// A smaller schedule for simpler tests
export const DAILY_SCHEDULE_SMALL: DailyScheduleListDto = [
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-1")
    .withTimeRange(9, 0, 10, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Sandra", "Graham")
    .withParticipants(12, 15, 1)
    .withTrials(2)
    .withDropIns(1)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-2")
    .withTimeRange(12, 0, 13, 0)
    .withProgramName("WOD")
    .withColor("#FF6B6B")
    .withCoach("Gregory", "Miller")
    .withParticipants(15, 18, 0)
    .withTrials(1)
    .buildDto(),
  DailyScheduleSlotEntityBuilder.create()
    .withSlotId("slot-3")
    .withTimeRange(18, 0, 19, 0)
    .withProgramName("Yoga")
    .withColor("#9C27B0")
    .withCoach("Emma", "Wilson")
    .withParticipants(8, 10, 2)
    .buildDto(),
]

// Empty schedule for testing empty state
export const DAILY_SCHEDULE_EMPTY: DailyScheduleListDto = []
